import React from 'react';

const NoData = () => {
  return (
    <div style={{ padding: '8rem' }}>
      <div className="ui active big loader" />
    </div>
  );
};

export default NoData;



/** WEBPACK FOOTER **
 ** ./src/components/layout/loadingContent/LoadingContent.js
 **/